import AddNewChargeBtn from "../AddNewChargePoint/AddNewChargePoint";
import NewChargePointFormModal from "../NewChargePointFormModal/NewChargePointFormModal";

export interface AddNewChargeBtnModalProps {
    modalId?: string;


}


export default function AddNewChargeBtnModal({modalId}: AddNewChargeBtnModalProps) {

    const modalIdFound = modalId || "add-new-charge-point-modal"
    return <><AddNewChargeBtn modalId={modalIdFound}/>
    <NewChargePointFormModal modalId={modalIdFound}/>
    </>

}
